module.exports = __webpack_public_path__ + "assets/33f331ce04d24d71227f6dce12dbe8e8.mp4";